import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-tertiary)";

function IconHintClose({ color, class: cssClass }: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm1.941 3.766L8 6.708 6.059 4.766a.918.918 0 0 0-1.29.003.91.91 0 0 0-.003 1.29L6.708 8 4.766 9.941a.918.918 0 0 0 .003 1.29.91.91 0 0 0 1.29.002L8 9.293l1.941 1.94a.918.918 0 0 0 1.29-.002.91.91 0 0 0 .002-1.29L9.293 8l1.94-1.941a.918.918 0 0 0-.002-1.29.91.91 0 0 0-1.29-.003z" fill={fill}/>
        </svg>
    );
}

export default IconHintClose;
